import { MHTTPCL } from "../../../services/http/http-client";
import { SETTINGS_URL } from "../../../services/common-urls";

export const NoticesService = {
  findNotices: () => MHTTPCL.get(SETTINGS_URL, {
    section: 'notices',
    output: 'json',
  }),
}